import { FC } from 'react';
import { ReleasePageView } from './ReleasePageView';

export const ReleasePage: FC = () => <ReleasePageView />;
